import * as Immutable from 'immutable';
import {createAction} from 'redux-actions';
import {createSelector} from 'reselect';
import {actionTypes as system} from "../System";
import {handleActions} from '../../Utility/HandleActions';

//action types
const SAGA_LOAD_DATA_START = "DBM/DATA/CURRENCY/SAGA_LOAD_DATA_START";
const SAGA_LOAD_DATA_SUCCESS = "DBM/DATA/CURRENCY/SAGA_LOAD_DATA_SUCCESS";
const SAGA_LOAD_HOLIDAYS_START = "DBM/DATA/CURRENCY/SAGA_LOAD_HOLIDAYS_START";
const SAGA_LOAD_HOLIDAYS_SUCCESS = "DBM/DATA/CURRENCY/SAGA_LOAD_HOLIDAYS_SUCCESS";
const REQUEST_CURRENCIES = "DBM/DATA/CURRENCY/REQUEST_CURRENCIES";
const REQUEST_HOLIDAYS = "DBM/DATA/CURRENCY/REQUEST_HOLIDAYS";

const sagaLoadDataStart = createAction(SAGA_LOAD_DATA_START);
const sagaLoadDataSuccess = createAction(SAGA_LOAD_DATA_SUCCESS);
const sagaLoadHolidaysStart = createAction(SAGA_LOAD_HOLIDAYS_START);
const sagaLoadHolidaysSuccess = createAction(SAGA_LOAD_HOLIDAYS_SUCCESS);
const requestRetrieveCurrencies = createAction(REQUEST_CURRENCIES);
const requestRetrieveHolidays = createAction(REQUEST_HOLIDAYS);

export const actionTypes = {
    SAGA_LOAD_DATA_START,
    SAGA_LOAD_DATA_SUCCESS,
    SAGA_LOAD_HOLIDAYS_START,
    SAGA_LOAD_HOLIDAYS_SUCCESS,
    REQUEST_CURRENCIES,
    REQUEST_HOLIDAYS
};

export const actions = {
    sagaLoadDataStart,
    sagaLoadDataSuccess,
    sagaLoadHolidaysStart,
    sagaLoadHolidaysSuccess,
    requestRetrieveCurrencies,
    requestRetrieveHolidays
};

export const reducer = handleActions({
    [system.INIT]: () => {
        return (state) => {
            let newState = state;
            newState = newState.setIn(['data', 'currency', 'currencies'], Immutable.fromJS([]));
            newState = newState.setIn(['data', 'currency', 'holidays'], Immutable.fromJS({}));
            newState = newState.setIn(['data', 'currency', 'currencyPairs'], Immutable.fromJS([]));
            return newState;
        }
    },
    [SAGA_LOAD_DATA_START]: () => {
        return (state) => {
            let newState = state;
            newState = newState.setIn(['data', 'currency', 'currencies'], Immutable.fromJS([]));
            newState = newState.setIn(['data', 'currency', 'holidays'], Immutable.fromJS({}));
            newState = newState.setIn(['data', 'currency', 'currencyPairs'], Immutable.fromJS([]));
            return newState;
        }
    },
    [SAGA_LOAD_DATA_SUCCESS]: (data) => {
        // TODO: The API does not provide a status to distinguish base from counter currencies.
        // We are assuming 'EUR' is the only base currency for pair generation.
        const base = data.filter((it) => {
            return it.status === 'BASE';
        });

        const counter = data.filter((it) => {
            return it.status === 'COUNTER';
        });

        const ccyPairs = [];

        base.forEach((b) => {
            counter.forEach((c) => {
                if (b.isoString !== c.isoString) {
                    ccyPairs.push(b.isoString + c.isoString);
                }
            });
        });

        return (state) => {
            let newState = state;
            newState = newState.setIn(['data', 'currency', 'currencies'], Immutable.fromJS(data));
            newState = newState.setIn(['data', 'currency', 'currencyPairs'], Immutable.fromJS(ccyPairs.sort()));
            return newState;
        }
    },
    [SAGA_LOAD_HOLIDAYS_SUCCESS]: (actionData) => {
        return (state) => {
            let payload = actionData;
            if (typeof payload === 'string') {
                try { payload = JSON.parse(payload); } catch(e) {}
            }
            
            // Aggressively unwrap 'data' nesting if it exists
            if (payload && payload.data && typeof payload.data === 'object' && !Array.isArray(payload.data)) {
                payload = payload.data;
            }
            return state.setIn(['data', 'currency', 'holidays'], Immutable.fromJS(payload || {}));
        }
    }

});

const getCurrencyState = (state) => state.getIn(['data', 'currency']);

const getCurrencies = createSelector(getCurrencyState, (currencyState) =>
    currencyState ? currencyState.get('currencies').toJS() : []
);
const getCurrencyPairs = createSelector(getCurrencyState, (currencyState) =>
    currencyState ? currencyState.get('currencyPairs').toJS() : []
);

const getCurrencyByIsoString = createSelector(
    (state) => state.getIn(['data', 'currency', 'currencies']),
    (state, ccyIso) => ccyIso,
    (currencies, ccyIso) => {
        return currencies.length > 0 ? currencies.toJS().filter(ccy => ccy.isoString === ccyIso)[0] : null;
    }
);
const getHolidays = createSelector(getCurrencyState, (currencyState) =>
    currencyState ? currencyState.get('holidays').toJS() : {}
);

export const selectors = {
    getCurrencies,
    getCurrencyPairs,
    getCurrencyByIsoString,
    getHolidays
};
